export const COMMODITY_NAME_HEATING_OIL = "Heating Oil";
export const COMMODITY_NAME_NATURAL_GAS = "Natural Gas";
export const COMMODITY_NAME_CRUDE = "Crude";
export const COMMODITY_NAME_SOYBEAN_MEAL = "Soybean Meal";
export const COMMODITY_NAME_SOYBEAN_OIL = "Soybean Oil";

export const CROP_PROFILE_ADDITIONAL_COMMODITY_NAMES = [
  COMMODITY_NAME_HEATING_OIL,
  COMMODITY_NAME_NATURAL_GAS,
  COMMODITY_NAME_CRUDE,
  COMMODITY_NAME_SOYBEAN_MEAL,
  COMMODITY_NAME_SOYBEAN_OIL,
];

export function mergeCropProfileCommodities(commodities = []) {
  const extra = CROP_PROFILE_ADDITIONAL_COMMODITY_NAMES.map((commodity_name) => ({ commodity_name }));
  return [...commodities, ...extra].filter(
    (item, index, arr) =>
      item?.commodity_name && arr.findIndex((row) => row.commodity_name === item.commodity_name) === index
  );
}
